import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <>
      <div className="col-md-2">
        <ul className="nav flex-column">
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>

          <li>
            <a
             
              data-bs-toggle="collapse"
              href="#collapseExample"
             
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              Cards
            </a>
            <div className="collapse" id="collapseExample">
              <div className="card-body">
                <li>
                  <Link to="/createcard">Create Card</Link>
                </li>
                <li>
                  <Link to="/cardslist">Card List</Link>
                </li>
              </div>
            </div>
          </li>

          <li>
            <Link to="#">Customers</Link>
          </li>
          <li>
            <Link to="/orders">Orders</Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
